/* eslint-disable @typescript-eslint/ban-ts-comment */
// Using ts-ignore in this because of the "upload" component which needs to be replaced.
import isArray from 'lodash/isArray';
import noop from 'lodash/noop';
import querystring from 'querystring';
import axios from 'axios';
// @ts-ignore
import Upload from 'component-upload';
var hostname = window.location.hostname;
var WebAPIUtils = /** @class */ (function () {
    function WebAPIUtils() {
    }
    WebAPIUtils.prototype.get = function (url, data, callback) {
        this.request(url, { method: 'GET', data: data }, callback);
    };
    WebAPIUtils.prototype.post = function (url, data, callback) {
        this.request(url, { method: 'POST', data: data }, callback);
    };
    WebAPIUtils.prototype.put = function (url, data, callback) {
        this.request(url, { method: 'PUT', data: data }, callback);
    };
    WebAPIUtils.prototype.delete = function (url, data, callback) {
        this.request(url, { method: 'DELETE', data: data }, callback);
    };
    WebAPIUtils.prototype.request = function (url, opts, cb) {
        var options = opts;
        var settings = {
            hostname: options.hostname || hostname,
            path: url,
            method: options.method || 'GET',
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        };
        var callback = cb || noop;
        var newData = {};
        if (options.data) {
            if (isArray(options.data)) {
                options.data.forEach(function (item, i) {
                    if (typeof item === 'object' && item !== null) {
                        Object.entries(item).forEach(function (_a) {
                            var key = _a[0], value = _a[1];
                            newData["data[".concat(i, "][").concat(key, "]")] = String(value);
                        });
                    }
                });
                options.data = newData;
            }
            var queryData = querystring.stringify(options.data);
            switch (options.method) {
                case 'POST':
                case 'PUT':
                    settings.headers = {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    };
                    break;
                case 'GET':
                    settings.headers = {
                        'X-Requested-With': 'XMLHttpRequest',
                        'Cache-Control': 'no-cache'
                    };
                    settings.path += "?".concat(queryData);
                    break;
                default:
                    // No special handling needed for other methods
                    break;
            }
        }
        axios({
            method: settings.method,
            url: settings.path,
            data: options.data,
            headers: settings.headers
        })
            .then(function (response) {
            if (response.status === 200) {
                callback(null, response.data);
            }
            else {
                callback(response.data);
            }
        })
            .catch(function (error) {
            callback(error);
        });
    };
    /**
     * TODO: We need to replace this with something that is Typescript friendly.
     */
    WebAPIUtils.prototype.upload = function (url, file, data, endCallback, progressCallback) {
        var upload = new Upload(file);
        // @ts-ignore
        var error = null;
        upload.to({
            path: url,
            name: 'data[Upload][file]',
            data: data
        });
        // @ts-ignore
        upload.on('progress', function (progress) {
            progressCallback(progress);
            console.log("Uploaded ".concat(progress.loaded, " bytes out of ").concat(progress.total, " bytes"));
        });
        // @ts-ignore
        upload.on('error', function (errorResponse) {
            if (errorResponse && errorResponse.error) {
                error = errorResponse.error;
            }
            else {
                error = 'Unable to upload image';
            }
        });
        // @ts-ignore
        upload.on('end', function (rsp) {
            var response;
            try {
                response = JSON.parse(rsp.response);
                if (!response.success) {
                    if (response.error) {
                        error = response.error;
                    }
                    else {
                        error = 'Unable to upload image';
                    }
                }
            }
            catch (e) {
                error = 'Unable to upload image';
            }
            // @ts-ignore
            endCallback(error, response);
        });
    };
    WebAPIUtils.prototype.fetchApplicationData = function (callback) {
        this.get('/admin/get_all_data', {
            ie_fix: new Date().getTime()
        }, callback);
    };
    WebAPIUtils.prototype.getAppSettings = function (callback) {
        this.get('/admin/get_app_settings', {}, callback);
    };
    return WebAPIUtils;
}());
// Create and export a singleton instance
export default new WebAPIUtils();
